import { observable, reaction } from 'mobx';

export const progressBarStore = observable({
	isReady: false,
	progress: 0
});

reaction(
	() => progressBarStore.progress,
	(progress) => {
		// Aquí puedes colocar la lógica para manejar el cambio de progreso
		// console.log('El progreso ha cambiado a:', progress);

		// Por ejemplo, podrías actualizar la interfaz de usuario con el nuevo progreso
		updateProgressBarUI(progress);
	}
);

function updateProgressBarUI(progress) {
	// Esta función actualiza la interfaz de usuario con el nuevo progreso
	// Puedes implementar esta función de acuerdo a la lógica de tu aplicación
	// Por ejemplo, podrías cambiar el ancho de una barra de progreso en la pantalla
}
